import {
  Box,
  Container,
  Heading,
  Text,
  Image,
  Stack,
  Button,
  SimpleGrid,
  UnorderedList,
  ListItem,
} from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import Navbar from "./Navbar";
import ProcessImage from "./images/mrcaiprocess2.png";
import HeroImage from "./images/stamps.png";

const ProcessDescription = () => {
  const navigate = useNavigate();

  return (
    <Box>
      <Navbar />

      {/* Background image */}
      <Image
        src={HeroImage}
        alt="Hero Watermark"
        width="100%"
        height="100%"
        objectFit="cover"
        opacity={0.30}
        position="absolute"
        top={0}
        left={0}
        zIndex={-1}
        filter="blur(1px)"
      />

      <Container maxW="container.xl" py={8}>
        <Stack spacing={8} align="stretch">
          {/* Process Map - Large and Prominent */}
          <Box
            bg="rgba(255,255,255,0.95)"
            p={10}
            borderRadius="lg"
            boxShadow="xl"
            textAlign="center"
          >
            <Image
              src={ProcessImage}
              alt="mrc.ai Process Map"
              maxW="100%"
              mx="auto"
              mb={8}
            />

            {/* Four Columns: SUBMISSION, QUOTE, ORDER, BIND */}
            <SimpleGrid columns={{ base: 1, md: 2, lg: 4 }} spacing={6}>
              <Box>
                <Heading size="lg" color="blue.600" mb={4}>
                  SUBMISSION
                </Heading>
                <UnorderedList color="gray.700" fontSize="md" lineHeight="1.8" textAlign="left" spacing={2}>
                  <ListItem>Build Submissions</ListItem>
                  <ListItem>Connect Insurable Interest data to Contracts</ListItem>
                  <ListItem>Collaborate on Contract terms and conditions with Clients</ListItem>
                </UnorderedList>
              </Box>

              <Box>
                <Heading size="lg" color="blue.600" mb={4}>
                  QUOTE
                </Heading>
                <UnorderedList color="gray.700" fontSize="md" lineHeight="1.8" textAlign="left" spacing={2}>
                  <ListItem>Manage the Quote cycle</ListItem>
                  <ListItem>Handle Programs and Options</ListItem>
                  <ListItem>Collaborate on Contract terms with Lead (Re)Insurers</ListItem>
                </UnorderedList>
              </Box>

              <Box>
                <Heading size="lg" color="blue.600" mb={4}>
                  ORDER
                </Heading>
                <UnorderedList color="gray.700" fontSize="md" lineHeight="1.8" textAlign="left" spacing={2}>
                  <ListItem>Manage the Firm Order cycle</ListItem>
                  <ListItem>Handle Follower participation</ListItem>
                  <ListItem>Finalise </ListItem>
                </UnorderedList>
              </Box>

              <Box>
                <Heading size="lg" color="blue.600" mb={4}>
                  BIND
                </Heading>
                <UnorderedList color="gray.700" fontSize="md" lineHeight="1.8" textAlign="left" spacing={2}>
                  <ListItem>Manage Signing down</ListItem>
                  <ListItem>Bind Contracts</ListItem>
                  <ListItem>Create Policy Headers</ListItem>
                </UnorderedList>
              </Box>
            </SimpleGrid>

            <Box textAlign="center" mt={8}>
              <Button
                colorScheme="blue"
                size="lg"
                onClick={() => navigate("/")}
                boxShadow="lg"
                _hover={{ transform: "scale(1.05)" }}
                transition="all 0.2s"
              >
                Back to Home
              </Button>
            </Box>
          </Box>
        </Stack>
      </Container>
    </Box>
  );
};

export default ProcessDescription;
